<template>
    <div>
        <div class="row">
            <div class="col-12">
                <b-button v-if="btn" class="mb-2" variant="info" @click="adicionar">
                    <i class="fas fa-plus mr-2"></i>
                    Inserir
                </b-button>
            </div>
            <input-select class="col-12 col-md-3" :min="1998" :label="'Ano inicial'" :options="anos" v-model="ano"/>
            <input-select class="col-12 col-md-3" :disabled="!ano" label="Mês inicial" :options="mesesFiltrado" v-model="mesInicio"/>
            <input-select class="col-12 col-md-2" :disabled="!ano" :min="1998" label="Ano final" :options="anosFiltrado" v-model="anoFim"/>
            <input-select class="col-12 col-md-4" :disabled="!ano" label="Mês final" :options="mesesFiltrado" v-model="mesFim">
                <template #append>
                    <b-button v-if="!dashboard" class="ml-2" @click="buscar()">
                        <i class="fas fa-search"></i>
                    </b-button>
                </template>
            </input-select>  
            <div class="col-12 d-flex" v-if="dashboard">
                <b-button variant="success" @click="buscar()">
                    <i class="fas fa-search mr-2"></i>
                    Filtrar
                </b-button>
                
                <b-button variant="outline-primary" @click="limpar" class="ml-2">
                    Limpar
                </b-button>
            </div>   
        </div>
        <hr v-if="!dashboard">
    </div>
</template>
<script>
import helpers from "@/common/utils/helpers";
import InputSelect from "@/components/inputs/InputSelect";
export default {
    components : {
        InputSelect
    },
    props : {
        btn : {
            type : Boolean,
            default : false,
        },
        dashboard : {
            type : Boolean,
            default : false,
        },
        filtro : {
            default : () => {
                return {};
            }
        },
    },
    data : () => ({
        anos : [],
        meses : [],
        ano : null,
        anoFim : null,
        mesInicio : null,
        mesFim : null,
    }),
    methods : {
        montar : function(){
            this.inicializarAnos();
        },
        inicializarAnos : function(){
            this.meses = [
                {
                    text : "Todos meses",
                    value : null,
                },
                ...helpers.retornarMeses()
            ];
            let ano = new Date().getFullYear();
            this.anos = [];
            this.anos.push({
                text : "Todos anos",
                value : null,
            });
            for (let index = ano; index >= 1998; index--) {
                this.anos.push(index);            
            }
            this.buscar();
        },
        
        buscar : function(){
            this.$emit('buscar',{ano : this.ano, anoFim: this.anoFim, mesInicio : this.mesInicio, mesFim : this.mesFim})
        },

        adicionar : function(){
            this.$emit('adicionar');
        },

        limpar : function(){
            this.ano = null;
            this.anoFim = null;
            this.mesInicio = null;
            this.mesFim = null;
        },
    },
    mounted(){
        if(this.dashboard){
            this.montar();
        }
    },
    watch : {
        filtro : {
            handler : function(){
                this.ano = this.filtro.ano || null;
                this.anoFim = this.filtro.anoFim || null;
                this.mesInicio = this.filtro.mesInicio || null;
                this.mesFim = this.filtro.mesFim || null;
            },
            immediate : true,
        },
        ano : function(valor){
            if(!valor){
                this.mesInicio = null;
                this.mesFim = null;
                this.anoFim = null;
                return;
            }

            if(this.anoFim < valor){
                this.anoFim = valor;
            }

            if(this.mesInicio == null){
                this.mesInicio = 1;
            }

            if(this.mesFim == null){
                this.mesFim = 12;
            }
        },
        anoFim : function(valor){
            if(this.ano > valor){
                this.ano = valor;
            }
        },
    },
    computed : {
        mesesFiltrado : function(){
            if(this.ano != null){
                return this.meses.filter(el => el.value != null);
            }

            return this.meses;
        },

        anosFiltrado : function(){
            if(this.ano != null){
                return this.anos.filter(el => el != null);
            }

            return this.anos;
        }
    }
}
</script>
<style lang="">
    
</style>